import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6855f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduce" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "introduce-banner banner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "warp outer-package" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "b global-title" }, "白海科技"),
    /*#__PURE__*/_createElementVNode("div", { class: "b global-title" }, "新一代云原生AI基础软件服务商")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IntroduceTable = _resolveComponent("IntroduceTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_IntroduceTable)
  ]))
}